import { Component, effect, input, model, output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideIcons } from '@ng-icons/core';
import { lucideChevronDown, lucideSearch, lucideX } from '@ng-icons/lucide';

import { BrnSelectImports } from '@spartan-ng/brain/select';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmButtonGroupImports } from '@spartan-ng/helm/button-group';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { HlmInputGroupImports } from '@spartan-ng/helm/input-group';
import { HlmDropdownMenuImports } from '@spartan-ng/helm/dropdown-menu';
import { HlmSelectImports } from '@spartan-ng/helm/select';

@Component({
  selector: 'app-input-search',
  imports: [
    ReactiveFormsModule,
    HlmInputImports,
    HlmIconImports,
    HlmDropdownMenuImports,
    HlmInputImports,
    HlmButtonImports,
    FormsModule,
    HlmInputGroupImports,
    HlmButtonGroupImports,
    BrnSelectImports,
    HlmSelectImports,
  ],
  templateUrl: './input-search.component.html',
  providers: [provideIcons({ lucideSearch, lucideChevronDown, lucideX })],
})
export class InputSearchComponent {
  readonly placeholder = input<string>('Rechercher');

  readonly onFilter = output<{ nom: string; niveau?: number | null }>();

  nom = model<string | null>();
  niveau = model<number | null>();

  constructor() {
    effect(() => {
      const nom = this.nom();
      const niveau = this.niveau();

      if (nom && nom.length > 0) this.onFilter.emit({ nom, niveau });
    });
  }

  setLevel = (value?: number) => this.niveau.set(value);

  clearName() {
    this.nom.set('');
  }
}
